import { useTranslation } from 'react-i18next';

import { Button, ErrorAlert } from 'components/ui';

type Props = {
  onRetry: () => void;
  compact?: boolean;
};

export const DamagesTablePreferenceError = ({ onRetry, compact = false }: Props) => {
  const { t } = useTranslation();
  const message = t(
    'common.damagesTablePreloadingLoadError',
    'Unable to load the Damages table preloading preference.'
  );
  const retryLabel = t('common.damagesTablePreloadingRetry', 'Retry');

  if (compact) {
    return (
      <span>
        <div>{message}</div>
        <Button type="link" onClick={onRetry}>
          {retryLabel}
        </Button>
      </span>
    );
  }

  return <ErrorAlert message={message} action={<Button onClick={onRetry}>{retryLabel}</Button>} />;
};
